import { Injectable } from '@angular/core'
import { deserialize, DocumentObject } from 'jsonapi-fractal'

@Injectable({ providedIn: 'root' })
export class FractalService {
  deserialiseItem<Response, Model>(
    response: unknown,
    map: (data: Response) => Model
  ): Model {
    const deserialised = deserialize<Response>(response as DocumentObject)
    if (!deserialised || Array.isArray(deserialised)) {
      throw new Error('Invalid response')
    }
    return map(deserialised)
  }

  deserialiseList<Response, Model>(
    response: unknown,
    map: (data: Response) => Model
  ): Model[] {
    const deserialised = deserialize<Response>(response as DocumentObject)
    if (!deserialised || !Array.isArray(deserialised)) {
      throw new Error('Invalid response')
    }
    return deserialised.map(map)
  }
}
